module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingBonus/images/landing-bonus-ico-vehicle-large.6febee49.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingBonus/images/landing-bonus-ico-vehicle-large.png
// module id = 3117
// module chunks = 11